module.exports = __webpack_public_path__ + "static/media/Impreza-GD-Sedan.6ceca425.webp";